<template>
<div>
    <div class="description text-grey-darken-1" v-html="product.description"></div>
    <div v-if="params.length" class="mt-4 mt-md-12" :class="{
        'bg-grey-lighten-5 rounded-lg mb-4 pa-8 pb-5': $vuetify.display.smAndDown
    }">
        <v-row>
            <v-col v-for="parameter in params" cols="12" md="6">
                <div class="border-b d-flex justify-space-between mt-n3 pb-2 ga-2">
                    <span class="text-black font-weight-bold">{{ parameter.title }}{{
                            parameter.unit ? ` [${parameter.unit}]` : ''
                        }}:</span>
                    <v-spacer></v-spacer>
                    <template v-if="parameter.values">
                        <template v-for="(value, index) in parameter.values" :key="index">
                            <a v-if="value.link" :href="value.link"
                               class="text-cis-accent-color" target="_blank" v-html="value.value">
                            </a>
                            <span v-else v-html="value.value" class="text-grey"></span>
                            <template v-if="index + 1 !== parameter.values.length">
                                <span class="text-grey-darken-1">, </span>
                            </template>
                        </template>
                    </template>
                    <span v-else v-html="parameter.value" class="text-grey"></span>
                </div>
            </v-col>

        </v-row>
    </div>
</div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    product: Object
})
const filterVariant = (param, paramValues) => {
    const option = props.product.variants.options.find(item => item.id_parameters === param.parameter.id);
    if (option) {
        const value = paramValues.find(item => item.id === option.id_products_parameters_values);
        if (value) {
            return [value]
        }
    }
    return null;
}

const params = computed(() => {
    return formatParams(props.product.product_parameters)
})

const formatParams = (params) => {
    const paramsComputed = [];
    if (params) {
        params.forEach((param) => {
            if (param.parameter.type === 'text') {
                let values;
                let paramValues = param.products_parameters_values;
                if(props.product.is_variant){
                    paramValues = filterVariant(param, paramValues) || paramValues;
                }
                values = paramValues.map((val) => {
                    const obj = {};
                    if (props.product.default_group?.id && param.parameter.use_in_filter) {
                        //obj.link = `${props.product.default_group.url}/${param.parameter.slug}_${val.parameters_values.slug}`
                    }
                    if (param.parameter.show_as === 'colors') {
                        obj.value = `<span class="color-dot" style="background-color: ${val.parameters_values.show_as}"></span>`
                    } else {
                        obj.value = val.parameters_values.show_as || val.parameters_values.name
                    }
                    return obj
                });
                if (values.length) {
                    paramsComputed.push({
                        title: param.parameter.name,
                        unit: param.parameter.unit,
                        show_as: param.parameter.show_as,
                        values,
                    });
                }
            } else {
                let values;
                let paramValues = param.products_parameters_values;
                if(props.product.is_variant){
                    paramValues = filterVariant(param, paramValues) || paramValues;
                }
                values = paramValues.map((val) => val.parameters_values?.show_as || val.parameters_values?.name || val.value);
                if (values.length) {
                    paramsComputed.push({
                        title: param.parameter.name,
                        unit: param.parameter.unit,
                        show_as: param.parameter.show_as,
                        value: values.join(', '),
                    });
                }
            }
        });
    }
    return paramsComputed;
}

</script>

<style scoped lang="scss">
.description {
    font-size: .934rem;
    line-height: 1.6;
    :deep(ul), :deep(ol) {
        padding-left: 20px;

    }
    :deep(img) {
        max-width: 100%;
        object-fit: contain;
    }
}
:deep(.color-dot) {
    display: inline-block;
    width: 1.2em;
    height: 1.2em;
    border-radius: 50%;
    box-shadow: 0 0 .7em grey;
}
</style>
